<div class="relative w-full h-full overflow-hidden">
  @if (text.isLoading()) {
    <div class="absolute inset-0 flex items-center justify-center bg-white z-10">
      <app-loading-indicator>Loading file...</app-loading-indicator>
    </div>
  } @else if (text.error()) {
    <app-preview-error [error]="text.error()"/>
  } @else if (renderAsMarkdown()) {
    <div class="w-full h-full overflow-auto px-6 py-4 bg-white">
      <app-markdown-viewer [data]="text.value()"/>
    </div>
  } @else {
    <pre class="m-0 w-full h-full overflow-auto p-8 bg-white text-gray-900 font-mono text-base whitespace-pre-wrap break-words in-[app-files-main-view]:[scrollbar-gutter:stable] in-[app-files-main-view]:[&::-webkit-scrollbar]:w-8! in-[app-files-main-view]:[&::-webkit-scrollbar-thumb]:border-[5px] in-[app-files-main-view]:[&::-webkit-scrollbar-thumb]:border-transparent in-[app-files-main-view]:[&::-webkit-scrollbar-thumb]:bg-clip-padding">{{ text.value() }}</pre>
  }
</div>
